<template>
  <div class="checkbox" :class="{ checked: modelValue || indeterminate, disabled, indeterminate }" :style="vars" @click="toggle">
    <div class="checkbox-dash" v-if="indeterminate"></div>
    <div class="checkbox-tick" v-else></div>
  </div>
</template>

<script>
export default {
  name: 'CheckBox',
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    color: { type: String, default: 'var(--color-primary)' },
    thickness: { type: String, default: '2px' }
  },
  computed: {
    vars() {
      return {
        '--cb-color': this.color,
        '--cb-thickness': this.thickness
      }
    }
  },
  emits: ['update:modelValue'],
  methods: {
    toggle() {
      if (this.disabled) return
      this.$el.classList.add('checkbox-animate')
      setTimeout(() => {
        this.$el.classList.remove('checkbox-animate')
      }, 150)
      this.$emit('update:modelValue', !this.modelValue)
    }
  }
}
</script>

<style scoped>
.checkbox {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 1px solid #d1d5db;
  background: #FFF;
  border-radius: 4px;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.15s ease;
}

.checkbox:hover:not(.disabled):not(.checked) {
  border-color: #9ca3af;
}

.checkbox.checked {
  background: var(--cb-color);
  border-color: var(--cb-color);
}

.checkbox.disabled {
  background: #fafafa;
  opacity: 0.5;
  cursor: not-allowed;
}

.checkbox.checkbox-animate {
  transform: scale(0.85);
}

.checkbox-tick {
  width: 5px;
  height: 10px;
  margin-top: -2px;
  margin-left: 1px;
  border: solid #FFF;
  border-width: 0 var(--cb-thickness) var(--cb-thickness) 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.15s ease;
}

.checkbox.checked .checkbox-tick {
  opacity: 1;
}

.checkbox-dash {
  width: 10px;
  height: 2px;
  background: #FFF;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.checkbox.indeterminate .checkbox-dash {
  opacity: 1;
}
</style>
